import { DragDropContext,Draggable,Droppable,DropResult } from "@hello-pangea/dnd";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import HelpIcon from '@mui/icons-material/Help';
import MenuIcon from '@mui/icons-material/Menu';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button,Card,Checkbox,Divider,FormControlLabel,IconButton,Stack,TextField,Tooltip,Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType,ItemChecklist } from "../../types/checklist/types";
import EditSubitem from "./EditSubitem";
import DeletaItem from "./Modal/DeletaItem";

type props = {
  item: ItemChecklist,
  index: number,
  handleOpenItem: Function
  open: string[];
};

export default function EditItem({ item, index, handleOpenItem, open }: props) {
  const { t } = useTranslation('translation');
  const { modelo, setModelo } = useContext(NewFormContext);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [dragDisableSub, setDragDisableSub] = useState(false);
  const [openSubitem, setOpenSubitem] = useState<string[]>([]);

  function handleCloseModal() {
    setOpenModal(!openModal);
  }

  function handleCopyItem() {
    let newItem = { ...item };
    newItem.nome = `${newItem.nome} ${t('copy')}`;
    newItem.id = `${modelo?.id}|${modelo?.versao}|${modelo?.itens.length}`;
    setModelo((prev: ChecklistType) => ({
      ...prev, itens: [...prev.itens, newItem]
    }));
  }

  function handleAddNewSubitem(itemId: string) {
    setModelo((prevModelo: ChecklistType) => ({
      ...prevModelo,
      itens: prevModelo.itens.map(item =>
        item.id === itemId
          ? {
            ...item,
            subitens: [
              ...item.subitens,
              {
                id: item.subitens.length,
                nome: 'Novo Subitem',
                itemid: item.id,
                tipo: 'avaliacao',
                avaliacao: [{ nome: '1', valor: 0 }, { nome: '2', valor: prevModelo.valorMaxScoring }],
                peso: 1,
                threshold: -1
              }
            ]
          }
          : item
      )
    }));
  }

  function handleCopySubitem(subitem: ChecklistSubitem, itemId: string) {
    const cloneSubitem = structuredClone(subitem);
    cloneSubitem.nome = `${cloneSubitem.nome} ${t('copy')}`;
    cloneSubitem.id = item.subitens.length;
    setModelo((prevModelo: ChecklistType) => ({
      ...prevModelo,
      itens: prevModelo.itens.map(item =>
        item.id === itemId
          ? {
            ...item,
            subitens: [
              ...item.subitens,
              cloneSubitem
            ]
          }
          : item
      )
    }));
  };

  function reorder(list: [], startIndex: number, endIndex: number) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function handleDragEnd(result: DropResult) {
    if (!result.destination) return;

    if (result.destination.index === result.source.index) return;

    const items = reorder(
      item?.subitens as [],
      result.source.index,
      result.destination.index
    );

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((ite) =>
        ite.id === item.id
          ? {
            ...ite,
            subitens: items,
          }
          : ite
      ),
    }));
  }

  function handelOpen(value: string) {
    const next = openSubitem.includes(value)
      ? openSubitem.filter((openValue) => openValue !== value)
      : [...openSubitem, value];
    setOpenSubitem(next);
    setDragDisableSub(next.length > 0);
  }

  return (
    <>
      {openModal && <DeletaItem itemId={item?.id} open={openModal} nome={item?.nome} handleCloseModal={handleCloseModal} />}
      <Stack width='100%' spacing={1}>
        <Grid container width='100%' padding={1}>
          <Stack direction='row' alignItems='flex-start' justifyContent='flex-start' spacing={1} width='100%'>
            <Grid size={1.5}>
              <Card>
                <Typography textAlign='center' variant="h5" color='success' fontWeight={600} padding={1}>
                  Item - {index + 1}
                </Typography>
              </Card>
            </Grid>
            <Grid size={5}>
              <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1.5} width='100%'>
                <TextField
                  fullWidth
                  label='Nome do item'
                  value={item?.nome}
                  onChange={(eve) => setModelo((prev: ChecklistType) => ({
                    ...prev, itens: prev.itens.map((ele) => ele.id === item.id
                      ? { ...ele, nome: eve.target.value } : ele), key: item.id
                  }))} />
                {item.ocorrenciaMultipla
                  && <TextField
                    fullWidth
                    label='Nome da ocorrencia múltipla'
                    value={item?.nomeOcorrencia}
                    onChange={(eve) => setModelo((prev: ChecklistType, ind: number) => ({
                      ...prev, itens: prev.itens.map((ele) => ele.id === item.id
                        ? { ...ele, nomeOcorrencia: eve.target.value } : ele), key: ind
                    }))} />}
              </Stack>
            </Grid>
            <Grid size={1.2}>
              <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1.5} width='100%'>
                <TextField
                  fullWidth
                  slotProps={{
                    htmlInput: {
                      min: 0,
                      max: 100,
                      step: 1,
                    }
                  }}
                  type="number"
                  label='Peso do item'
                  value={item?.peso}
                  onChange={(eve) => setModelo((prev: ChecklistType) => ({
                    ...prev, itens: prev.itens.map((ele) => ele.id === item.id
                      ? { ...ele, peso: parseInt(eve.target.value) } : ele)
                  }))}
                />
                {item.ocorrenciaMultipla &&
                  <TextField
                    fullWidth
                    slotProps={{
                      htmlInput: {
                        min: 0,
                        max: 100,
                        step: 1,
                      }
                    }}
                    type="number"
                    label='Nº Ocorrências'
                    value={item?.maxOcorrencias}
                    onChange={(eve) => setModelo((prev: ChecklistType) => ({
                      ...prev, itens: prev.itens.map((ele) => ele.id === item.id
                        ? { ...ele, maxOcorrencias: parseInt(eve.target.value) } : ele)
                    }))}
                  />}
              </Stack>
            </Grid>
            <Grid size={2.5}>
              <Stack direction='column' alignItems='flex-start' justifyContent='space-between' spacing={4} width='100%' height='100%'>
                <FormControlLabel labelPlacement="start"
                  control={<Checkbox checked={item.ocorrenciaMultipla}
                    onChange={(eve) => setModelo((prev: ChecklistType) => ({
                      ...prev, itens: prev.itens.map((ele) => ele.id === item.id
                        ? eve.target.checked ? { ...ele, ocorrenciaMultipla: eve.target.checked, nomeOcorrencia: 'Nova ocorrência' }
                          : { ...ele, ocorrenciaMultipla: eve.target.checked }
                        : ele)
                    }))}
                  />} label='Ocorrência múltipla' />
                {item.ocorrenciaMultipla &&
                  <Tooltip title='caso não seja definido um valor poderão ser abertas ocorrências ilimitadas'>
                    <HelpIcon color='info' />
                  </Tooltip>}
              </Stack>
            </Grid>
            <Stack height='100%' alignItems='flex-start'>
              <Grid size={1}>
                <Stack direction='row' spacing={.5}>
                  <Tooltip title='Exibir/Ocultar item'>
                    <span>
                      <IconButton color="info" onClick={() => handleOpenItem(item.id)}>
                        {open.includes(item.id)
                          ? <VisibilityOffIcon />
                          : <RemoveRedEyeIcon />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title='Copiar item'>
                    <span>
                      <IconButton color="success" onClick={handleCopyItem}>
                        <ContentCopyIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title='Deletar item'>
                    <span>
                      <IconButton color="error" onClick={handleCloseModal} disabled={modelo?.itens?.length === 1}>
                        <DeleteIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Stack>
              </Grid>
            </Stack>
            <Divider variant="middle" orientation='horizontal' flexItem />
          </Stack>
        </Grid>
        {open.includes(item.id) &&
          <>
            <Divider orientation='horizontal' flexItem />
            <Stack direction='column' justifyContent='flex-start' alignItems='center' spacing={1} paddingRight={1} width='100%'>
              <Stack spacing={2} direction='row' alignItems='center' justifyContent='flex-end' width='100%'>
                <Button
                  endIcon={item.subitens.length === openSubitem?.length ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                  onClick={() => {
                    const totalSub = item.subitens?.length;
                    if (totalSub === openSubitem?.length) {
                      setOpenSubitem([]);
                      setDragDisableSub(false);
                    } else {
                      setOpenSubitem(item.subitens.map((subitem) => `${item.id}|${subitem.id}`));
                      setDragDisableSub(true);
                    }
                  }}>
                  {item.subitens.length === openSubitem?.length ? t('checklists.fecharSubitens') : t('checklists.abrirSubitens')}
                </Button>
                <Button
                  color="success"
                  onClick={() => handleAddNewSubitem(item.id)}
                  variant="contained"
                  sx={{ textTransform: 'none', fontWeight: 800, fontSize: 18 }}
                  size="small"
                  endIcon={<AddCircleOutlineIcon />}
                >
                  Novo subitem
                </Button>
              </Stack>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="avaliacao">
                  {(provided) => (
                    <Stack paddingBottom={1} width='100%' direction='column' spacing={.5} {...provided.droppableProps} ref={provided.innerRef}>
                      {item.subitens?.map((subitem, i) => (
                        <Draggable isDragDisabled={dragDisableSub} key={`${subitem.id}|${item.id}`} draggableId={`${subitem.id}|${item.id}`} index={i}>
                          {(provided) => (
                            <Stack width='100%' alignItems='flex-start' justifyContent='flex-start' direction='row' spacing={.5} key={`${subitem.id}|${item.id}`} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                              <div style={{ marginTop: 22 }}>
                                <IconButton disabled={item.subitens?.length <= 1 || dragDisableSub}>
                                  <MenuIcon />
                                </IconButton>
                              </div>
                              <Stack direction='column' justifyContent='flex-start' alignItems='center' spacing={1} width='100%' key={`${subitem.id}|${item.id}`}>
                                <Divider variant="middle" color='success' flexItem orientation='horizontal'
                                  sx={{
                                    borderColor: '#00C4A7',
                                    borderWidth: 2,
                                  }} />
                                <EditSubitem
                                  handleOpen={handelOpen}
                                  open={openSubitem}
                                  handleCopySubitem={handleCopySubitem}
                                  handleDragDisableSubitem={() => undefined}
                                  itemId={item.id}
                                  key={`${item.id}|${subitem.id}`}
                                  item={item}
                                  subitem={subitem}
                                  indexItem={index}
                                  indexSubitem={i}
                                />
                              </Stack>
                            </Stack>)}
                        </Draggable>
                      ))}
                    </Stack>)}
                </Droppable>
              </DragDropContext>
            </Stack>
          </>}
      </Stack>
    </>
  );
}
